import { createFileRoute } from '@tanstack/react-router'
import { usePageTitle } from '../../../features/page-title/pageTitle'
import { ProfilePage } from '../../../features/profile/ProfilePage.tsx'
import { me } from '../../../i18n.ts'

export const Route = createFileRoute('/me/_settings/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  const t = me.useT()
  usePageTitle(t('pageTitle.profile'))
  return <ProfilePage />
}
